import { err, ok } from 'neverthrow'
import { z } from 'zod'
import { TSafeParseReturnType } from './types'
import { ValidationFail } from './ValidationFail'

export const safeParse = <
  S extends z.ZodTypeAny = z.ZodType<unknown, z.ZodTypeDef, unknown>,
>(
  schema: S,
  data: unknown,
  params?: Partial<z.ParseParams>,
): TSafeParseReturnType<S> => {
  const parseResult = schema.safeParse(data, params)
  if (parseResult.success) return ok(parseResult.data)

  return err(
    new ValidationFail("Object didn't match expected shape.", {
      cause: parseResult.error,
    }),
  )
}
